import { render, staticRenderFns } from "./IpercTabla.vue?vue&type=template&id=54eababc&scoped=true"
import script from "./IpercTabla.vue?vue&type=script&lang=js"
export * from "./IpercTabla.vue?vue&type=script&lang=js"
import style0 from "./IpercTabla.vue?vue&type=style&index=0&id=54eababc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eababc",
  null
  
)

export default component.exports